import Head from 'next/head'
import { useRef, useState } from 'react';

import styles from './styles.module.scss'

import checkWhitespace from '../../Functions/checkWhitespace'
import axios from 'axios';

import LoadingSpinner from '../../Account/LoadingSpinner/LoadingSpinner'

import errorMsg from '../../Functions/errorMsg';

export default function Contact() {

  const firstNameRef = useRef(null);
  const emailRef = useRef(null);
  const messageRef = useRef(null);

  const [contactSuccess, setContactSuccess] = useState(false);
  const [pendingContact, setPendingContact] = useState(false);

  const submitContact = async (e) => {
    e.preventDefault();
    setPendingContact(true);

    if(checkWhitespace(firstNameRef.current.value)) {
      errorMsg('Please enter your first name.');
      setPendingContact(false);
      return;
    }

    if(checkWhitespace(emailRef.current.value)) {
      errorMsg('Please enter a contact email.');
      setPendingContact(false);
      return;
    }

    if(checkWhitespace(messageRef.current.value)) {
      errorMsg('Please enter a message.');
      setPendingContact(false);
      return;
    }

    if(!emailRef.current.value.includes('@')) {
      errorMsg("Please include an @ and .com in your email.");
      setPendingContact(false)
      return;
    }

    const result = await axios.post(`${window.location.origin}/api/contact/message`, {
      first: firstNameRef.current.value,
      email: emailRef.current.value,
      message: messageRef.current.value,
    }).catch((error) => {
      if(error?.response?.data?.status !== undefined) {
        errorMsg(error?.response?.data?.status);
        setPendingContact(false)
      } else {
        errorMsg(error);
        setPendingContact(false)
      }
    })

    if(result !== undefined) {
        if(result.status === 200) {
          setContactSuccess(true);
          setPendingContact(false);
        } else {
          errorMsg('There was a problem verifying your account, please try again later.');
          setPendingContact(false);
        }
    }



  }

  return (
    <section className={styles.contactWrapper}>
      <Head>
        <title>Waco Exchange - Contact</title>
        <meta charSet="utf-8" />
        <link rel="icon" href="/pageIcons/favicon.ico" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="apple-touch-icon" href="/pageIcons/icon.png" />
      </Head>
      <form id={styles.contactForm} onSubmit={e => submitContact(e)}>
        {
          contactSuccess === false ?
          <>
            <h1>Contact Us</h1>
            <span>
              <h2>First Name</h2>
              <input ref={firstNameRef} type="text" placeholder="Enter your first name" />
            </span>
            <span>
              <h2>Contact Email</h2>
              <input ref={emailRef} type="email" placeholder="Enter a contact email" />
            </span>
            <span>
              <h2>Your message</h2>
              <textarea ref={messageRef} placeholder="What would you like to tell us?" />
            </span>

            <button type="submit"> {pendingContact === true ? <LoadingSpinner width='25px' height='25px' color="white" /> : 'Send Message' }</button>
          </>
          :
          <>
            <h1>Contact message sent!</h1>
            <p>Please give us 24-48 hours to get back</p>
          </>
        }
      </form>
    </section>
  )
}
